<!--
 * @Author: your name
 * @Date: 2021-01-03 19:49:41
 * @LastEditTime: 2021-01-28 11:16:01
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xdap-h5\src\lib\ui\components\form\form-ocr-input\form-ocr-input.vue
-->
<template>
  <div class="form-Orc-input">
    <div class="form-item-content">
      <x-proxy-form-item
        :showRequired="showRequired"
        :label="widget.label"
        :processTitle="widget.processTitle"
        :validatorRules="validatorRules"
        :validateKey="validateKey"
        :validateInfo="validateInfo"
        :disabled="widget.readOnly"
      >
        <x-upload
          v-model="uploadValue"
          ref="xUpload"
          :click="false"
          :renderSence="renderSence"
          :uploadLimit="4"
          :uploadNumber="1"
          :readOnly="widget.readOnly"
          :postUpload="handleUpload"
          :beforeUpload="beforeUpload"
          :beforeRemove="beforeRemove"
          :removeUpload="removeUpload"
          @download="handleDownload"
          @cancal-upload="cancalUploadFile"
        ></x-upload>
      </x-proxy-form-item>
      <div class="form-upload-suffix" :class="{ 'is-fixed': uploadValue && uploadValue.length > 0 || loadingStack.length > 0 }" v-if="canUpload" @click="handleClick">
        <x-svg-icon name="x-lib-upload"></x-svg-icon>
      </div>
    </div>
  </div>
</template>

<script>
import FormWidgetConfigMixin from '../../../mixins/form-widget.mixin'
import XUpload from '../../x-upload/x-upload'
import { mapAdapter } from '../form-build-action'
import { isWechat } from '../../../utils/platform.util.js'
import { blobToFile, compressImg } from '@/vender/third-sdk/third-function/get-camera.js'
import { isOnlyWechat } from '@/lib/ui/utils/platform.util.js'

const SelectComponentTypes = [
  'FORM_RADIO_INPUT',
  'FORM_SELECT_INPUT',
  'FORM_CHECKBOX_INPUT'
]

export default {
  name: 'FormOrcInput',
  mixins: [FormWidgetConfigMixin],
  components: {
    XUpload
  },
  data() {
    return {
      loadingStack: [],
      uploadFileFunction: null
    }
  },
  computed: {
    canUpload() {
      return this.renderSence === 'edit' && !this.widget.readOnly && (!this.uploadValue || this.uploadValue && this.uploadValue.length === 0) ? true : false
    },
    uploadValue: {
      get() {
        let formValue
        if (this.formValue instanceof Array) {
          formValue = this.formValue
        } else {
          formValue = [this.formValue]
        }
        if (formValue && formValue[0] && formValue[0].id) {
          return formValue.map(item => {
            return {
              ...item,
              src: this.getImgSrc(item)
            }
          })
        } else {
          return []
        }
      },
      set(value) {
        if (value instanceof Array) {
          let data = value.map(item => {
            delete item.src
            return item
          })
          this.formValue = data[0] ? data[0] : null
        } else {
          this.formValue = value ? value : null
        }
      }
    }
  },
  methods: {
    ...mapAdapter(['initData', 'uploadFile', 'removeUpload', 'uploadFileInWx']),
    handleUpload(data) {
      const u = navigator.userAgent
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      return new Promise(async (resolve, reject) => {
        let params = {}
        if (isOnlyWechat() && isiOS) {
          params.file = data
          params.componentId = this.widget.uuid
          params.globalData = this.globalData
          if (!params.globalData.formId) {
            params.globalData.formId = this.$route.query.formId
          }
          this.uploadFileFunction = this.uploadFileInWx
        } else {
          params.data = await compressImg(data)
          params.componentId = this.widget.uuid
          params.globalData = this.globalData
          if (!params.globalData.formId) {
            params.globalData.formId = this.$route.query.formId
          }
          this.uploadFileFunction = this.uploadFile
        }
        this.uploadFileFunction(params).then(resp => {
          if (resp.code === 'ok') {
            resolve({
              ...resp.data.attachments,
              status: 'completed',
              src: this.getImgSrc(resp.data.attachments)
            })
            const ocrData = resp.data.ocrData
            this.setFormData(ocrData)
            this.loadingStack.pop()
          } else {
            this.loadingStack.pop()
          }
        }, (err) => {
          this.loadingStack.pop()
          reject(err)
        }).catch(err => {
          reject(err)
        })
      })
    },
    setFormData(ocrData) {
      let formData = ocrData.formData
      let tableData = ocrData.tableData
      const formComponentIds = Object.keys(formData)
      const tableComponentIds = Object.keys(tableData)
      const formItemList = this.formConfigList.map(item => item.componentConfig)
      if (formComponentIds && formComponentIds.length > 0) {
        formComponentIds.forEach(uuid => {
          formData[uuid] = this.getComponentOptionsConfig(uuid, formData[uuid], formItemList)
          this.updatePropValue(uuid, formData[uuid])
        })
      }
      if (tableComponentIds && tableComponentIds.length > 0) {
        tableComponentIds.forEach(uuid => {
          tableData[uuid] = this.getTableComponentConfig(uuid, tableData[uuid], formItemList)
          const formTableData = this.formData[uuid] || []
          tableData[uuid] = [...tableData[uuid], ...formTableData]
          this.updatePropValue(uuid, tableData[uuid])
        })
      }
    },
    beforeRemove(file) {
      return new Promise((resolve, reject) => {
        this.$confirm({
          message: '是否确定删除该文件？',
          okConfig: {
            onOk() {
              resolve()
            }
          },
          cancelConfig: {
            onCancel() {
              reject()
            }
          }
        })
      })
    },
    // 单选框，多选框，下拉框 获取中文对应的code
    getComponentOptionsConfig(uuid, value, formItemList) {
      let dataValue = value
      if (formItemList && formItemList.length > 0) {
        const specialComponent = formItemList.find(component => SelectComponentTypes.includes(component.componentType) && component.uuid === uuid)
        try {
          if (specialComponent && specialComponent.chooseOptions) {
            const chooseOptions = specialComponent.chooseOptions
            // const chooseType = specialComponent.chooseType
            let labelObj = chooseOptions.find(option => option.label === value)
            dataValue = labelObj && labelObj.id ? [labelObj.id] : []
          }
          return dataValue
        } catch (error) {
          console.error('error 下拉框、单选框或多选框解析错误')
        }
      }
    },
    // 解析表格组件中的单选多选下拉
    getTableComponentConfig(uuid, value, formItemList) {
      let dataValue = value
      try {
        if (dataValue instanceof Array) {
          if (dataValue && dataValue.length > 0) {
            const tableObj = formItemList.find(item => item.componentType === 'FORM_WIDGET_TABLE' && item.uuid === uuid)
            dataValue.forEach(item => {
              Object.keys(item).forEach(uuid => {
                item[uuid] = this.getComponentOptionsConfig(uuid, item[uuid], tableObj.tableColumn)
              })
            })
          }
        } else {
          dataValue = this.getComponentOptionsConfig(uuid, value, formItemList)
        }
        return dataValue
      } catch (error) {
        console.error('error 表格组件解析错误')
      }
    },
    getImgSrc(data) {
      if (data) {
        const params = this.$base64.encode(JSON.stringify({
          xdaptenantid: data.tenantId,
          xdaptoken: this.$axios.defaults.headers.xdaptoken
        }))
        return data.url && `${data.url}&token=${params}`
      } else {
        return ''
      }
    },
    beforeUpload() {
      this.loadingStack.push(true)
    },
    handleClick() {
      if (!this.widget.readOnly) {
        this.$refs.xUpload && this.$refs.xUpload.chooseFile()
      }
    },
    handleDownload(file) {
      if (isWechat()) {
        this.$compRouter.push(this.$options.name, {
          key: this.propKey,
          widgetConfig: this.widget,
          value: file
        })
      } else {
        window.open(file.src + '&download=download', '_self')
      }
    },
    cancalUploadFile(data) {
      if (this.widget.abort instanceof Function) {
        this.loadingStack.pop()
        this.widget.abort()
      }
    }
  }
}
</script>

<style lang="scss">
.form-Orc-input {
  position: relative;
  display: flex;
  align-items: center;
  .form-item-content {
    width: 100%;
  }
  .x-proxy-form-item {
    padding-right: 0;
    width: 100%;
  }
  .form-upload-suffix {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 3.43rem;
    width: 3.43rem;
    height: calc(100% - 1.71rem);
    font-size: 0;
    color: $--app-base-font-color;
    height: 100%;
    &.is-fixed {
      height: 3.43rem;
    }
  }
}
</style>